<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <index-table id="reseller-index-table" endpoint="resellersIndex" title="Resellers" icon="store">
                <template slot="head">
                    <index-table-head slug="name">Name</index-table-head>
                    <index-table-head slug="subdomain">Subdomain</index-table-head>
                    <index-table-head slug="email">E-mail</index-table-head>
                    <index-table-head slug="active" class="text-center">Is active</index-table-head>
                    <index-table-head slug="actions" :sortable="false" class="text-center"></index-table-head>
                </template>
              <md-table-row class="search">
                <index-table-filter-text slug="name"></index-table-filter-text>
                <index-table-filter-text slug="subdomain"></index-table-filter-text>
                <index-table-filter-text slug="email"></index-table-filter-text>
                  <index-table-filter-bool slug="active"></index-table-filter-bool>
                  <md-table-cell></md-table-cell>
              </md-table-row>
                <resellers-row v-for="(item, key) in items" :key="key" :item="item"/>

            </index-table>
        </div>
    </div>
</template>

<style>
.search .md-table-cell{
  padding: 0 12px;
  border-top: none;
}
</style>


<script>
    import {mapGetters, mapMutations} from "vuex";
    import IndexTable from "../../components/Index/IndexTable";
    import IndexTableHead from "../../components/Index/IndexTableHead";
    import ResellersRow from "./ResellersRow";
    import IndexTableFilterText from "@/new/components/Index/IndexTableFilterText";
    import IndexTableFilterBool from "@/new/components/Index/IndexTableFilterBool";

    export default {
        name: "Resellers",
        components: {ResellersRow, IndexTableHead, IndexTable, IndexTableFilterText, IndexTableFilterBool},
        computed: {
            ...mapGetters('indexTable', {
                items: 'getItems',
            }),
        },
        data() {
            return {
            }
        },
        methods: {
            ...mapMutations('app', {
                setTitlePage: 'setTitlePage',
            })
        },
        mounted() {
            this.setTitlePage(this.$t('Resellers'));
        }
    }
</script>